export const getLocalStorageItem = (key) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(key)
  }
  return null // Return null if localStorage is not available (SSR)
}

// Safely set an item in localStorage
export const setLocalStorageItem = (key, value) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(key, value)
  }
}

// Safely clear all localStorage
export const clearLocalStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.clear()
  }
}

// Phone number fomatter
const countryPhoneFormats = {
  US: { format: '(XXX) XXX-XXXX', maxLength: 14, requiredDigits: 10 },
  MN: { format: 'XXXX-XXXX', maxLength: 9, requiredDigits: 8 },
}

const countryCodeMap = {
  USA: 'US',
  UnitedStates: 'US',
  'United States': 'US',

  MN: 'MN',
  Mongolia: 'MN',
}

export const phoneNumberFormatter = (numbers = '', countryCode = 'US') => {
  numbers = numbers.replace(/\D/g, '')

  const normalizedCountry = countryCodeMap[countryCode] ?? countryCode
  const config = countryPhoneFormats[normalizedCountry] ?? countryPhoneFormats.US
  const { format, maxLength } = config

  let formattedNumber = ''
  let numberIndex = 0

  for (const char of format) {
    if (numberIndex >= numbers.length) break

    if (char === 'X') {
      formattedNumber += numbers[numberIndex++]
    } else {
      formattedNumber += char
    }
  }

  return formattedNumber.slice(0, maxLength)
}
export const getRequiredPhoneDigits = (countryCode = 'US') => {
  const normalized = countryCodeMap[countryCode] ?? countryCode
  return countryPhoneFormats[normalized]?.requiredDigits ?? 10
}
export const validatePhone = (_, value, selectedCountry = 'US') => {
  if (!value) {
    return Promise.reject(new Error('Утасны дугаараа оруулна уу!'))
  }

  const digits = value.replace(/\D/g, '')
  const requiredDigits = getRequiredPhoneDigits(selectedCountry)

  if (digits.length !== requiredDigits) {
    return Promise.reject(
      new Error(selectedCountry === 'MN' ? `Утасны дугаар ${requiredDigits} оронтой байна.` : `Утасны дугаар ${requiredDigits} оронтой байна.`),
    )
  }

  return Promise.resolve()
}

export const formatPhone = (value, country = 'US') => {
  if (!value) return ''

  const cleaned = value.replace(/\D/g, '').slice(0, 10)

  const zip = cleaned.substring(0, 3)
  const middle = cleaned.substring(3, 6)
  const last = cleaned.substring(6, 10)

  const first4 = cleaned.substring(0, 4)
  const last4 = cleaned.substring(4, 8)

  if (country === 'MN') {
    if (cleaned.length > 4) return `${first4} ${last4}`
    if (cleaned.length > 0) return `${first4}`
    return ''
  }

  if (cleaned.length > 6) return `(${zip}) ${middle}-${last}`
  if (cleaned.length > 3) return `(${zip}) ${middle}`
  if (cleaned.length > 0) return `(${zip}`

  return ''
}
export const formatPhoneNoCountry = (number) => {
  if (number) {
    const cleaned = number.replace(/\D/g, '').substring(0, 10)
    const zip = cleaned.substring(0, 3)
    const middle = cleaned.substring(3, 6)
    const last = cleaned.substring(6, 10)
    const first4 = cleaned.substring(0, 4)
    const last4 = cleaned.substring(4, 8)
    let ret = ''
    if (number.length === 10) {
      if (cleaned.length > 6) ret = `(${zip}) ${middle}-${last}`
      else if (cleaned.length > 3) ret = `(${zip}) ${middle}`
      else if (cleaned.length > 0) ret = `(${zip}`
    } else {
      if (cleaned.length > 4) ret = `${first4} ${last4}`
      else if (cleaned.length > 0) ret = `${first4}`
    }
    return ret
  }
  return ''
}
export const formatAndSetPhone = (value, country, formRef) => {
  const formatted = formatPhone(value, country)

  const possibleKeys = ['phoneNumber', 'phone', 'phonenumber', 'PhoneNumber', 'Phone', 'Phonenumber']
  const fields = formRef.getFieldsValue?.() || {}
  const targetKey = possibleKeys.find((k) => Object.prototype.hasOwnProperty.call(fields, k))

  if (!targetKey) {
    console.warn('No phone field found in form')
    return
  }

  formRef.setFieldsValue({ [targetKey]: formatted })
}
// Currency formatter
export const currencyFormatter = (amount, locale = 'en-US', currency = 'USD') => {
  if (amount === null || isNaN(amount)) return 'N/A'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
